import { ADD_AREA, DELETE_AREA, REFRESH_AREAS, UPDATE_AREA, SET_SELECTED_AREA } from "../actions/area.action";

const initialState = {
  areas: [],
};

const areaReducer = (state = initialState, action) => {
  switch (action.type) {
    case REFRESH_AREAS:
      return {
        ...state,
        areas: action.areas,
      };
    case ADD_AREA:
      return {
        ...state,
        areas: [...state.areas, action.area],
      };
    case UPDATE_AREA:
      return {
        ...state,
        areas: state.areas.map((area) =>
          area.id === action.area.id ? action.area : area
        ),
      };
    case DELETE_AREA:
      return {
        ...state,
        areas: state.areas.filter((area) => area.id !== action.areaId),
      };
    case SET_SELECTED_AREA:
      return {
        ...state,
        selectedArea: action.areaId,
      };
    default:
      return state;
  }
};

export default areaReducer;
